import { Text } from "@radix-ui/themes";

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

export const FeatureCard = ({ icon, title, description }: FeatureCardProps) => (
  <div className="p-4 rounded-xl bg-slate-50 dark:bg-slate-900 space-y-2">
    <div className="text-indigo-600 dark:text-indigo-400">{icon}</div>
    <Text className="font-medium block">{title}</Text>
    <Text className="text-sm text-slate-500 dark:text-slate-400 block">
      {description}
    </Text>
  </div>
);
